/**
 * Returns a Tailwind background-color class based on usage percentage.
 */
export function getBarColor(percent: number): string {
  if (percent >= 95) return 'bg-red-500';
  if (percent >= 80) return 'bg-amber-500';
  return 'bg-primary';
}

/**
 * Plan badge color map: bg + text classes keyed by plan type.
 */
const PLAN_BADGE_COLORS: Record<string, string> = {
  free: 'bg-white/10 text-white/60',
  prototype: 'bg-emerald-500/15 text-emerald-300',
  upkeep: 'bg-teal-500/15 text-teal-300',
  pro: 'bg-blue-500/15 text-blue-400',
  business: 'bg-violet-500/15 text-violet-400',
  agency: 'bg-amber-500/15 text-amber-400',
};

/**
 * Returns Tailwind color classes for a plan badge based on plan type.
 */
export function getPlanBadgeStyle(planType: string): string {
  return PLAN_BADGE_COLORS[planType] ?? PLAN_BADGE_COLORS.free;
}
